<iframe
  *ngIf="videoSource === 'YOUTUBE'"
  [src]="url"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
  class="youtube-video"
></iframe>
